import { Pressable } from '@react-aria/interactions'
import Styles from './IntegrationsDrawer.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { ChevronRightSmall } from 'blaze-ui/icons/24'
import { ReactNode } from 'react'

interface Props {
  onClick: () => void
  label: string
  icon: ReactNode
  rightElement?: ReactNode
}

export const Service = ({ onClick, icon, label, rightElement }: Props) => (
  <Pressable onPress={onClick}>
    <div className={Styles.service} data-testid={`service-${label}`}>
      <div className={Styles.serviceChannel}>
        {icon}
        <Text variant="largeList" color="var(--dark-80)">
          {label}
        </Text>
      </div>
      <div className={Styles.rightSide}>
        {rightElement}
        <ChevronRightSmall color="var(--dark-40)" />
      </div>
    </div>
  </Pressable>
)
